import { useEffect, useState } from "react";
import { api } from "../api/client";

type Status = { enabled: boolean; networks: Array<{ network: string; wallets: number }>; lastRegisteredAt: number | null };
export function WalletRegistryStatus(): JSX.Element {
  const [status, setStatus] = useState<Status | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try { const data = await api.get<Status>("/api/wallet-registry/status"); if (active) { setStatus(data); setFailed(false); } }
      catch { if (active) setFailed(true); }
    };
    void refresh();
    const timer = setInterval(() => void refresh(), 15_000);
    return () => { active = false; clearInterval(timer); };
  }, []);
  return <details className="card mb-4 p-4 text-xs">
    <summary className="cursor-pointer">Automatic wallet ignore · {failed ? "status unavailable" : !status ? "loading…" : `${status.networks.reduce((n, row) => n + row.wallets, 0)} addresses`}</summary>
    {status && <div className="mt-3 space-y-2 text-muted">
      <p>{status.enabled ? "Registration enabled. These addresses are ignored by all campaigns in their network." : "Registration disabled. Previously registered addresses remain ignored."}</p>
      {status.networks.map((row) => <p key={row.network}>{row.network}: {row.wallets}</p>)}
      <p>Last registration: {status.lastRegisteredAt ? new Date(status.lastRegisteredAt).toLocaleString() : "none"}. Delivery status is shown in the source tool.</p>
    </div>}
  </details>;
}
